<template>
  <div class="board" ref="board">
    <main-menu></main-menu>

    <div class="main">
      <template v-if="showSubMenu">
        <sub-menu class="main-left"></sub-menu>
      </template>

      <div
        class="content main-right"
        :class="{ activeContent: isCollapse }"
        id="content"
        ref="content"
      >
        <tabs-view v-if="showSubMenu"></tabs-view>
        <div class="tablelist-container" v-if="showSubMenu">
          <transition name="slide-fade">
            <router-view ref="view" class="tablelist loading-area"></router-view>
          </transition>
        </div>
        <transition v-else name="slide-fade">
          <router-view ref="view" class="tablelist loading-area"></router-view>
        </transition>
      </div>
    </div>

    <!-- <Footercus class="footer"></Footercus> -->
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import MainMenu from "../page/commons/menu/mainMenu/mainMenu";
import SubMenu from "../page/commons/menu/subMenu/subMenu";
import Bread from "./commons/bread.vue";
import Footercus from "./commons/footer.vue";
import TabsView from "./commons/TabsView.vue";
import $ from "jquery";
import websocket from "../helper/websocket";
import { Notification } from "element-ui";
import { menu_url } from "@/api/url";
import { animate } from "../page/commons/menu/common/js/animate";
export default {
  name: "maincus",
  data: function() {
    return {
      showSubMenu: false,
      fade: "fade",
    };
  },
  components: {
    // Headercus,
    // Sidecus,
    Bread,
    Footercus,
    MainMenu,
    SubMenu,
    TabsView,
  },
  created() {
    document.getElementById("appLoading").style.display = "none";
    websocket.websocketListener((msg) => {
      const pathHash = window.location.hash;
      if (pathHash === "#/main/home") {
        this.setArrearsList({...msg});
      } else {
        Notification({
          type: "info",
          title: msg.plate,
          message: msg.message,
          position: "bottom-right",
          duration: 0,
        });
      }
    });
  },
  mounted() {
    setInterval(() => {
      
    }, 1000);
    this.getAdminData();
    this.initMenuData();
    const r = this.$route.path;
    this.$nextTick(function() {
      if (r === "/main/home") {
        this.showSubMenu = false;
        this.$refs.content.classList.remove("main-right");
      } else {
        this.showSubMenu = true;
        this.$refs.content.classList.add("main-right");
      }
    });
  },
  computed: {
    ...mapState({
      isCollapse: (state) => state.menu.isCollapse,
      mainMenuHref: (state) => state.menu.mainMenuHref,
    }),
  },
  watch: {
    $route(newVal, oldVal) {
      this.$nextTick(function() {
        if (newVal.path === "/main/home") {
          this.showSubMenu = false;
          this.$refs.content.classList.remove("main-right");
          // 选中首页对应的顶级菜单
          this.selectHomeMenu();
        } else {
          this.showSubMenu = true;
          this.$refs.content.classList.add("main-right");
          // 同步菜单状态
          this.syncMenuState(newVal.path);
        }
      });
    },
  },
  methods: {
    ...mapActions(["getAdminData"]),
    ...mapActions("arrearsInformation", ["setArrearsList"]),
    ...mapActions("menu", [
      "setSubmenuList",
      "setMainMenuMovePlace",
      "setCurrentMovePlace",
      "setCurrentSubMenu",
      "setMenuData",
    ]),
    // 根据路由路径查找菜单项及其父菜单
    findMenuByPath(menuList, path) {
      for (const topMenu of menuList) {
        // 检查顶级菜单本身
        if (topMenu.href === path) {
          return { menu: topMenu, parent: null, topMenuIndex: menuList.indexOf(topMenu) };
        }
        // 递归检查子菜单
        const result = this.findMenuInChildren(topMenu.children || [], path, null, topMenu, menuList.indexOf(topMenu));
        if (result) return result;
      }
      return null;
    },
    findMenuInChildren(children, path, parent, topMenu, topMenuIndex) {
      for (const child of children) {
        if (child.href === path) {
          return { menu: child, parent: parent || topMenu, topMenuIndex };
        }
        if (child.children && child.children.length > 0) {
          const result = this.findMenuInChildren(child.children, path, child, topMenu, topMenuIndex);
          if (result) return result;
        }
      }
      return null;
    },
    // 同步菜单状态
    syncMenuState(routePath) {
      if (routePath === "/main/home") return;
      
      const menuData = this.$store.state.menu.menuData;
      if (!menuData || !menuData.length) return;

      const allMenus = menuData[0]?.children ?? [];
      const found = this.findMenuByPath(allMenus, routePath);
      
      if (!found) return;

      const topMenuIndex = found.topMenuIndex;
      if (topMenuIndex === -1 || topMenuIndex >= allMenus.length) return;

      // 设置顶级菜单位置
      const distance = topMenuIndex * 118;
      this.setMainMenuMovePlace({ place: distance });
      const moveDom = document.querySelector(".move");
      if (moveDom) {
        animate(moveDom, distance, "left");
      }

      // 设置侧边菜单
      const currentTopMenu = allMenus[topMenuIndex];
      const subMenuList = currentTopMenu.children.map((item, idx) => {
        const hasActiveChild = this.checkMenuHasActivePath(item, routePath);
        return {
          ...item,
          show: hasActiveChild,
          current: hasActiveChild && !item.children.length,
          children: item.children
            ? item.children.map((child) => ({
                ...child,
                current: child.href === routePath,
              }))
            : [],
        };
      });

      this.setSubmenuList(subMenuList);

      // 设置当前选中的子菜单
      const currentSubMenu = found.menu;
      if (currentSubMenu) {
        this.setCurrentSubMenu(currentSubMenu);
        
        // 设置侧边菜单的高亮位置
        // 找到包含当前菜单的一级菜单
        const firstMenu = subMenuList.find((first) => {
          if (first.href === routePath) return true;
          if (first.children && first.children.length > 0) {
            return first.children.some((child) => child.href === routePath);
          }
          return false;
        });

        if (firstMenu) {
          if (firstMenu.children && firstMenu.children.length > 0) {
            const secondMenuIndex = firstMenu.children.findIndex(
              (child) => child.href === routePath
            );
            if (secondMenuIndex !== -1) {
              const topDistance = secondMenuIndex * 58;
              this.setCurrentMovePlace({ place: topDistance });
              this.$nextTick(() => {
                const topMoveDom = document.querySelector(".top-move");
                if (topMoveDom) {
                  topMoveDom.classList.remove("init-top-move");
                  animate(topMoveDom, topDistance, "top");
                }
              });
            }
          }
        }
      }
    },
    // 检查菜单或其子菜单是否包含指定路径
    checkMenuHasActivePath(menu, path) {
      if (menu.href === path) return true;
      if (menu.children && menu.children.length > 0) {
        return menu.children.some((child) =>
          this.checkMenuHasActivePath(child, path)
        );
      }
      return false;
    },
    // 初始化菜单数据
    initMenuData() {
      this.$get(menu_url(), {}).then((data) => {
        const menuData = data[0]?.children ?? [];
        this.setMenuData([{ children: menuData }]);
        // 初始化后同步当前路由的菜单状态
        this.$nextTick(() => {
          this.syncMenuState(this.$route.path);
        });
      });
    },
    // 选中首页对应的顶级菜单
    selectHomeMenu() {
      const menuData = this.$store.state.menu.menuData;
      if (!menuData || !menuData.length) return;

      const allMenus = menuData[0]?.children ?? [];
      // 查找标题为"首页"的顶级菜单
      const homeMenuIndex = allMenus.findIndex(menu => menu.title === "首页");
      
      if (homeMenuIndex !== -1) {
        // 设置顶级菜单位置
        const distance = homeMenuIndex * 118;
        this.setMainMenuMovePlace({ place: distance });
        this.$nextTick(() => {
          const moveDom = document.querySelector(".move");
          if (moveDom) {
            animate(moveDom, distance, "left");
          }
        });
        
        // 清空侧边菜单和当前选中的子菜单
        this.setSubmenuList([]);
        this.setCurrentSubMenu({});
        this.setCurrentMovePlace({ place: 0 });
      }
    },
  },
};
</script>
<style scoped>

.board {
  min-width: 1440px;
  margin: 0 auto;
  height: 100%;
}

.headercus {
  width: 100%;
  /* height: 50px; */
  /* box-shadow: 0px 10px 20px #777; */
}
.footer {
  width: 100%;
  /* background:#f9f9fb;  */
  background: #ebeef5;
}
.main {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  /* margin-top:10px; */
  position: relative;
  height: calc(100% - 70px);
}
.main .main-right {
  width: calc(100% - 258px);
  /* background:#eff2f7; */
  /* z-index: 10000; */
  overflow: hidden;
  position: relative;
  /* border-radius: 5px; */
  /* overflow:auto; */
  height: 100%;
}
.main .content {
  width: 100%;
  padding-top: 0;
  height: 100%;
  overflow: hidden;
}

.main .activeContent {
  left: 64px;
  transition: all 0.3s ease;
}

.main-left {
  /* width: 15%; */
  width: 258px;
  /* background: #191c23; */
  overflow: hidden;
  overflow-y: auto;
}
.main-left::-webkit-scrollbar {
  display: none;
}
.tablelist-container {
  height: calc(100% - 40px);
  overflow: hidden;
}

.tablelist {
  height: 100%;
  background: white;
  overflow: auto;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.slide-fade-enter-active, .slide-fade-leave-active {
  transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}
.slide-fade-enter, .slide-fade-leave-to {
  opacity: 0;
  transform: translateX(40px);
}
.slide-fade-enter-to, .slide-fade-leave {
  opacity: 1;
  transform: translateX(0);
}
</style>
